<template>
  <section class="food-pyramid">
    <b-row>
      <b-col
        cols="12"
        lg="7"
        style="background-color: #E6F0FA;"
        class="foodpyramid-content"
      >
        <h2> Our Food Pyramid focuses on the essentials your body needs to thrive</h2>
        <h5
          v-if="showFoodListData"
          class="text-secondary-grey mt-2"
        >We use an advanced analytics platform to map your data to a nutrition database of hundreds of foods.<br><br>
          {{ contextBarcode.haveDNAData && contextBarcode.duBarcode !== '' ? 'The result is a personalized food list, selected to precisely balance your gut microbiome and improve current health.': 'The result is a personalized food list matched to your DNA, designed to reduce overall risks for health conditions you are genetically susceptible to.' }}
        </h5>
        <h5
          v-else
          class="text-secondary-grey mt-2"
        > We use an advanced analytics platform to map your data to a nutrition database of hundreds of foods.<br><br>
          The result is a precise set of dietary recommendations, tailor-made to suit your body.
        </h5>
      </b-col>
      <b-col
        cols="12"
        lg="5"
        class="p-0 text-md-center text-lg-right"
        style="background-color: #0A6ECA; overflow: hidden;"
      >
        <img
          v-if="contextBarcode.barcodeStatus !== 'Reports Ready'"
          src="@/assets/images/FP2.png"
        >
        <img
          v-else
          src="@/assets/images/FP1.png"
        >
      </b-col>
    </b-row>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    showFoodListData: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      contextBarcode: 'auth/GET_CONTEXT_BARCODE',
    }),
  },
}
</script>
<style lang="scss">
    .food-pyramid{
      img{
                  height: auto;
                  width: 32rem;

        }
      @media (min-width: 1025px) {

       img{
                  height: auto;
                  width: 36rem;
                  align-self: right;
        }
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        img{
          height: 21rem;
          width: auto;
        }
      }

      h2{
        color: black;
      }
      .foodpyramid-content{
        padding: 3rem;
        @media (min-width: 1025px) {
                  padding: 5rem;
        }
      }
    }
    .text-secondary-grey{
      color: #515151;
    }
</style>
